import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "event-log" }
const _hoisted_2 = { class: "event-log__header" }

import EventTable from "@/components/modules/EventJournal/EventTable.vue";
import {useEventLogStore} from "@/stores/event-log";
import {onMounted, computed, ref} from "vue";
import {storeToRefs} from "pinia";

const limit = 20;

// Флаг загрузки данных

export default /*@__PURE__*/_defineComponent({
  __name: 'EventLogView',
  setup(__props) {

const eventLogStore = useEventLogStore();

// Используем реактивные данные из store
const {eventsLog} = storeToRefs(eventLogStore);

// Количество элементов на странице
const { isLoadingEventsLog } = storeToRefs(eventLogStore);

// Значение поисковой строки
const eventSearchString = ref("");

// Вычисляемые свойства для paginator и списка событий
const paginator = computed(() => {
  if (!eventsLog.value || typeof eventsLog.value !== "object") {
    return {
      current_page: null,
      next_page: null,
      previous_page: null,
      total_items: 0,
      total_pages: 0
    };
  }

  return {
    current_page: eventsLog.value.current_page || null,
    next_page: eventsLog.value.next_page || null,
    previous_page: eventsLog.value.previous_page || null,
    total_items: eventsLog.value.total_items || 0,
    total_pages: eventsLog.value.total_pages || 0
  };
});

const eventLogList = computed(() => {
  if (!eventsLog.value || typeof eventsLog.value !== "object") {
    return [];
  }
  return eventsLog.value.results || [];
});

// Функция загрузки данных
const loadEventsLog = async (page = 1) => {
  try {
    isLoadingEventsLog.value = true;
    await eventLogStore.getEventsLogQuery(page, limit, eventSearchString.value);
  } catch (error) {
    console.error("Ошибка загрузки журнала событий:", error);
  } finally {
    isLoadingEventsLog.value = false;
  }
};

// Обработчик перехода на страницу
const handlePageChange = (page: number) => {
  loadEventsLog(page);
};

onMounted(() => {
  loadEventsLog(1);
});

let debounceTimer: number | null = null;

const loadEventsLogsDebounced = () => {
  if (debounceTimer) {
    clearTimeout(debounceTimer);
  }
  debounceTimer = setTimeout(() => {
    loadEventsLog(1);
  }, 300); // 300мс задержка
};


return (_ctx: any,_cache: any) => {
  const _component_InputSearchPrimary = _resolveComponent("InputSearchPrimary")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("h1", { class: "event-log__title" }, " Журнал событий ", -1)),
      _createVNode(_component_InputSearchPrimary, {
        modelValue: eventSearchString.value,
        "onUpdate:modelValue": [
          _cache[0] || (_cache[0] = ($event: any) => ((eventSearchString).value = $event)),
          loadEventsLogsDebounced
        ],
        size: "large",
        placeholder: "Найти"
      }, null, 8, ["modelValue"])
    ]),
    _createVNode(EventTable, {
      items: eventLogList.value,
      paginator: paginator.value,
      loading: _unref(isLoadingEventsLog),
      class: "event-log__table",
      onPageChange: handlePageChange
    }, null, 8, ["items", "paginator", "loading"])
  ]))
}
}

})